import React, { useEffect } from 'react';
import PageShell from './PageShell';
import Seo from '../components/Seo';
import { useI18n } from '../context/I18nContext';
import { publicApi } from '../api';
import { useApi } from '../hooks/useApi';
import { EmptyState, Spinner } from '../components/StateHelpers';
import { ExternalLink, Layers } from 'lucide-react';

export default function Projects() {
  const { lang, tr } = useI18n();
  const { data, loading } = useApi(() => publicApi.projects(lang), [lang]);
  useEffect(() => { document.title = 'Projelerimiz — Aegis Studios'; }, []);
  const items = data || [];

  return (
    <PageShell eyebrow="PROJELER" title={<><span className="text-white">{tr('projects.title1', 'Çalıştığımız')} </span><span className="gold-text">{tr('projects.title2', 'Projeler')}</span></>} subtitle={tr('projects.subtitle', 'Aegis Studios olarak geliştirdiğimiz seçili projeler.')}>
      <Seo title={tr('projects.title2', 'Projeler')} />
      <section className="pb-24">
        <div className="max-w-[1200px] mx-auto px-4 md:px-6 lg:px-10">
          {loading ? <Spinner /> : items.length === 0 ? (
            <EmptyState icon={Layers} title="Yakında" />
          ) : (
            <div className="grid md:grid-cols-2 gap-6">
              {items.map((p) => (
                <article key={p.id} className="relative rounded-3xl overflow-hidden border border-white/8 bg-gradient-to-b from-[#111015] to-[#0a090c] p-6 md:p-8 card-hover">
                  <div className="flex items-start justify-between mb-4">
                    <div className="w-12 h-12 rounded-2xl bg-[#e4b44e]/10 border border-[#e4b44e]/30 flex items-center justify-center"><Layers className="w-5 h-5 text-[#f4d896]" /></div>
                    {p.url && <a href={p.url} target="_blank" rel="noreferrer" className="text-white/60 hover:text-[#f4d896]"><ExternalLink className="w-4 h-4" /></a>}
                  </div>
                  <h3 className="font-display text-xl md:text-2xl font-black text-white mb-3">{p.name}</h3>
                  <p className="text-white/60 leading-relaxed">{p.description}</p>
                </article>
              ))}
            </div>
          )}
        </div>
      </section>
    </PageShell>
  );
}
